<template>
  <el-select
    v-model="auctionModel"
    @change="auctionChanged"
    autocomplete="new-password"
    :placeholder="$t('COMMON.AUCTION')"
    :filterable="filterable"
    :multiple="multiple"
    :disabled="disabled"
    remote
    :remote-method="getAuctions"
    :loading="loading"
    :allow-create="allowCreate"
  >
    <el-option v-if="showAll" :value="null" :label="$t('COMMON.ALL')">
    </el-option>
    <el-option v-if="allowNone" :value="null" :label="$t('COMMON.NONE')">
    </el-option>
    <el-option
      v-for="auction in auctions"
      :key="auction.id"
      :value="auction.id"
      :label="`${auction.name}`"
    >
    </el-option>
  </el-select>
</template>

<script>
import { Option, Select } from "element-ui";

export default {
  name: "auction-selector",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
      description: "Disable the input",
    },
    allowCreate: {
      type: Boolean,
      default: false,
      description: "Allow tag creation",
    },
    showAll: {
      type: Boolean,
      default: true,
      description: "Show the option all",
    },
    allowNone: {
      type: Boolean,
      default: false,
      description: "Show the option none",
    },
    filterable: {
      type: Boolean,
      default: true,
      description: "Can filter",
    },
    multiple: {
      type: Boolean,
      default: false,
      description: "Can filter",
    },
    auction: {
      type: String,
      default: null,
      description: "Auction id",
    },
    filterOrganization: {
      type: String,
      default: null,
      description: "Organization id",
    },
  },

  data() {
    return {
      auctionModel: this.auction,
      auctions: {},
    };
  },

  setup() {},

  created() {
    this.getAuctions(null, this.auction);
  },

  methods: {
    async getAuctions(query = null, id = null) {
      try {
        this.loading = true;
        let params = {
          sort: "name",
          filter: {
            ...(query ? { search: query } : {}),
            ...(id ? { id: id } : {}),
          },
        };

        if (this.filterOrganization) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              organization: this.filterOrganization,
            },
          };
        }

        await this.$store.dispatch("auctions/list", params);
        const auctionsArr = await this.$store.getters["auctions/list"];
        this.auctions = {};
        auctionsArr.forEach((auction) => {
          this.auctions[auction.id] = auction;
        });
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    auctionChanged(auction) {
      this.$emit("auctionChanged", auction);
    },
  },

  watch: {
    auction(auction) {
      if (auction) {
        this.auctionModel = auction;
        if (auction !== this.auctionModel) {
          //s this.getAuctions(null, auction);
        }
      } else {
        this.auctionModel = null;
      }
    },
    filterOrganization(filterOrganization) {
      this.getAuctions();
    },
  },
};
</script>
